import {
  createMatchTelemetry,
  startMatchTelemetry,
  endMatchTelemetry,
  buildMatchTelemetryRecord
} from '../../application/matchTelemetry.js';

/**
 * wireMatchTelemetryDebug — Optional `__debugTelemetry` smoke hook (SPY-61).
 */
export function wireMatchTelemetryDebug({
  session = createMatchTelemetry(),
  globalObj = typeof window !== 'undefined' ? window : null
} = {}) {
  const api = {
    start() {
      return startMatchTelemetry(session);
    },
    end(opts = {}) {
      return endMatchTelemetry(session, opts);
    },
    get() {
      return buildMatchTelemetryRecord(session);
    }
  };
  if (globalObj) globalObj.__debugTelemetry = api;
  return api;
}
